import React, { useState, useEffect } from 'react';

interface AuthImageProps {
  url: string;
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
  width?: string | number;
  height?: string | number;
}

const AuthImage: React.FC<AuthImageProps> = ({ url, alt = '', style, className, width, height }) => {
  const [imgSrc, setImgSrc] = useState<string | null>(null);

  useEffect(() => {
    let objectUrl: string | null = null;
    let isMounted = true;

    const fetchImage = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.ok && isMounted) {
          const blob = await response.blob();
          objectUrl = URL.createObjectURL(blob);
          setImgSrc(objectUrl);
        }
      } catch (error) {
        console.error("Error cargando la imagen segura", error);
      }
    };

    if (url) {
      if (url.includes('/api/image/') || url.includes('/api/file/')) {
        fetchImage();
      } else {
        setImgSrc(url);
      }
    }

    return () => {
      isMounted = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return imgSrc ? <img src={imgSrc} alt={alt} style={style} className={className} width={width} height={height} /> : <div>Cargando...</div>;
};

export default AuthImage;
